import { reactive } from 'vue'
import type { SalesOrder, SalesOrderStatus } from '@/types'

export interface SalesOrdersState {
  salesOrders: SalesOrder[]
  selectedOrder: SalesOrder | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    status: SalesOrderStatus | ''
    organizationId: string
  }
}

export const getInitialState = (): SalesOrdersState => ({
  salesOrders: [],
  selectedOrder: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    status: '',
    organizationId: '',
  },
})

export const createState = (): SalesOrdersState => {
  return reactive(getInitialState())
}

export const resetState = (state: SalesOrdersState): void => {
  const initial = getInitialState()
  state.salesOrders = initial.salesOrders
  state.selectedOrder = initial.selectedOrder
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
